module.exports = __webpack_public_path__ + "static/media/fintechna.a3b495d5.jpeg";